import { WifiOff } from 'lucide-react'
import { cn } from '../lib/cn.js'
import { isOldCopy, servedAtOf, fmtSavedAt } from '../lib/savedCopy.js'

/**
 * The line a calendar shows when what's on screen is the copy saved on this
 * phone, not a fresh answer (Charles, 2026-10-14) — so an empty-looking day
 * with no service is never taken for an empty day. Ink, like the shell's
 * offline strip; red stays for armed things.
 *
 * `missing`: there is nothing saved for what was asked; `missingText` says
 * what (e.g. "this day wasn't saved on this phone").
 */
export default function SavedCopyNote({ data, fetching = false, online = true, missing = false, missingText = '', extra = '', className = '' }) {
  let text = null
  if (missing) {
    text = `${online ? 'Couldn’t reach the server' : 'Offline'} — ${missingText}`
  } else if (data && (!online || (isOldCopy(data) && !fetching))) {
    const t = servedAtOf(data)
    const when = t ? ` at ${fmtSavedAt(t)}` : ''
    text = online
      ? `Couldn’t reach the server just now — showing the copy saved${when}`
      : `Offline — showing the copy saved on this phone${when}`
  }
  if (!text) return null
  return (
    <div role="status" className={cn('flex items-start gap-2 rounded-md bg-ink px-3 py-1.5 text-xs leading-snug text-white', className)}>
      <WifiOff size={13} className="mt-px shrink-0" aria-hidden />
      <span>
        {text}
        {extra && <span className="text-white/70"> · {extra}</span>}
      </span>
    </div>
  )
}
